let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5Wleb")).then(() => parcelRequire('b7081'));